import { render, staticRenderFns } from "./CardUserChartMobile.vue?vue&type=template&id=95b4bdf8"
import script from "./CardUserChartMobile.vue?vue&type=script&lang=js"
export * from "./CardUserChartMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports